import { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ChevronLeft, Lock, CreditCard, Truck, ExternalLink, Info } from 'lucide-react'
import { useCart } from '../context/CartContext'
import { useAuth } from '../context/AuthContext'
import Button from '../components/ui/Button'
import Input from '../components/ui/Input'

// Payment method icons/logos as simple SVG components
const PayPalLogo = () => (
  <svg viewBox="0 0 101 32" className="h-5 w-auto">
    <path fill="#003087" d="M12.237 2.8h-7.8c-.5 0-1 .4-1.1.9L.537 22c-.1.4.2.8.6.8h3.7c.5 0 1-.4 1.1-.9l.8-4.9c.1-.5.5-.9 1.1-.9h2.5c5.1 0 8.1-2.5 8.9-7.4.4-2.1 0-3.8-1-5-1.2-1.3-3.2-1.9-5.9-1.9zm.9 7.3c-.4 2.8-2.6 2.8-4.6 2.8h-1.2l.8-5.2c.1-.3.3-.5.6-.5h.5c1.4 0 2.7 0 3.4.8.4.5.5 1.2.4 2.1z"/>
    <path fill="#009cde" d="M35.437 10h-3.7c-.3 0-.6.2-.6.5l-.2 1-.3-.4c-.8-1.2-2.6-1.6-4.4-1.6-4.1 0-7.6 3.1-8.3 7.5-.4 2.2.1 4.3 1.4 5.7 1.2 1.3 2.9 1.9 4.9 1.9 3.5 0 5.4-2.2 5.4-2.2l-.2 1c-.1.4.2.8.6.8h3.4c.5 0 1-.4 1.1-.9l2-12.5c.1-.4-.2-.8-.6-.8zm-5.4 7.2c-.4 2.1-2 3.6-4.2 3.6-1.1 0-2-.3-2.5-1-.5-.7-.7-1.6-.5-2.7.3-2.1 2.1-3.6 4.1-3.6 1.1 0 1.9.4 2.5 1 .6.7.8 1.6.6 2.7z"/>
    <path fill="#003087" d="M55.337 10h-3.7c-.3 0-.7.2-.9.4l-5 7.4-2.1-7.1c-.1-.4-.5-.7-1-.7h-3.6c-.5 0-.8.4-.7.9l4 11.6-3.7 5.3c-.3.4 0 1 .5 1h3.7c.3 0 .7-.2.9-.4l12-17.3c.3-.5 0-1.1-.5-1.1z"/>
    <path fill="#009cde" d="M67.737 2.8h-7.8c-.5 0-1 .4-1.1.9l-3 18.3c-.1.4.2.8.6.8h4c.4 0 .7-.3.8-.7l.8-5.1c.1-.5.5-.9 1.1-.9h2.5c5.1 0 8.1-2.5 8.9-7.4.4-2.1 0-3.8-1-5-1.3-1.3-3.4-1.9-6-1.9zm.9 7.3c-.4 2.8-2.6 2.8-4.6 2.8h-1.2l.8-5.2c.1-.3.3-.5.6-.5h.5c1.4 0 2.7 0 3.4.8.4.5.5 1.2.4 2.1z"/>
    <path fill="#009cde" d="M90.937 10h-3.7c-.3 0-.6.2-.6.5l-.2 1-.3-.4c-.8-1.2-2.6-1.6-4.4-1.6-4.1 0-7.6 3.1-8.3 7.5-.4 2.2.1 4.3 1.4 5.7 1.2 1.3 2.9 1.9 4.9 1.9 3.5 0 5.4-2.2 5.4-2.2l-.2 1c-.1.4.2.8.6.8h3.4c.5 0 1-.4 1.1-.9l2-12.5c0-.4-.3-.8-.7-.8zm-5.4 7.2c-.4 2.1-2 3.6-4.2 3.6-1.1 0-2-.3-2.5-1-.5-.7-.7-1.6-.5-2.7.3-2.1 2.1-3.6 4.1-3.6 1.1 0 1.9.4 2.5 1 .6.7.8 1.6.6 2.7z"/>
    <path fill="#009cde" d="M95.137 3.3l-3 19.4c-.1.4.2.8.6.8h3.2c.5 0 1-.4 1.1-.9l3-18.3c.1-.4-.2-.8-.6-.8h-3.6c-.4 0-.6.2-.7.5z"/>
  </svg>
)

const AfterpayLogo = () => (
  <svg viewBox="0 0 100 24" className="h-4 w-auto">
    <path fill="#B2FCE4" d="M0 0h100v24H0z"/>
    <path fill="#000" d="M8 17.5h2.5l.8-2h4.4l.8 2H19L14 6.5h-2.5L6 17.5h2zm4.3-4.3l1.4-3.7 1.4 3.7h-2.8zM22 17.5V12c0-1.1.8-2 2-2h2v-2h-2.5c-2 0-4 1.5-4 4v5.5H22zm8 0V12c0-1.1.8-2 2-2h2.5v-2h-3c-2 0-3.5 1.5-3.5 4v5.5H30zm10.5-5.5H38v-2h2.5V8h2.5v2h3v2h-3v3.5c0 .8.7 1.5 1.5 1.5h1.5v2H44c-2 0-3.5-1.5-3.5-3.5v-3.5zm16 5.5v-5c0-2-1.5-3.5-3.5-3.5H48v2h5c.8 0 1.5.7 1.5 1.5v.5h-4c-2 0-3.5 1.5-3.5 3.5 0 1.5 1 2.5 2.5 2.5h4c1.5 0 3-1 3.5-2v1.5h2.5zm-2.5-3c0 1.1-.9 2-2 2h-2.5c-.8 0-1.5-.4-1.5-1s.7-1.5 1.5-1.5H54v.5zm10.5 3V12c0-1.1.7-2 1.5-2h1c.8 0 1.5.9 1.5 2v5.5h2.5V12c0-1.1.7-2 1.5-2h1c.8 0 1.5.9 1.5 2v5.5H78v-6c0-1.8-1.3-3.5-3-3.5h-1c-1.2 0-2.5.7-3 1.5-.5-1-1.8-1.5-3-1.5h-1c-1.7 0-3 1.7-3 3.5v6h2.5zM82 21V12c0-2 1.5-3.5 3.5-3.5H90v2h-4c-1.1 0-1.5.9-1.5 2v.5h5v2h-5v6H82z"/>
  </svg>
)

export default function Checkout() {
  const { cart, cartTotal } = useCart()
  const { user } = useAuth()
  const [isProcessing, setIsProcessing] = useState(false)
  const [error, setError] = useState('')

  const [formData, setFormData] = useState({
    email: user?.email || '',
    firstName: '',
    lastName: '',
    address: '',
    apartment: '',
    city: '',
    state: '',
    postcode: '',
    phone: '',
  })

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(price)
  }

  const shipping = cartTotal >= 75 ? 0 : 9.95
  const total = cartTotal + shipping

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    setError('')
  }

  const handleCheckout = async (e) => {
    e.preventDefault()
    setIsProcessing(true)
    setError('')

    try {
      // Call Netlify function to create Stripe checkout session
      const response = await fetch('/.netlify/functions/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: cart.map((item) => ({
            id: item.id,
            name: item.name,
            slug: item.slug,
            price: item.price,
            quantity: item.quantity,
            shortDescription: item.shortDescription,
            images: item.images,
          })),
          customerEmail: formData.email,
          shippingAddress: {
            name: `${formData.firstName} ${formData.lastName}`,
            line1: formData.address,
            line2: formData.apartment,
            city: formData.city,
            state: formData.state,
            postal_code: formData.postcode,
            country: 'AU',
            phone: formData.phone,
          },
        }),
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create checkout session')
      }

      // Redirect to Stripe Checkout
      if (data.url) {
        window.location.href = data.url
      } else {
        throw new Error('No checkout URL returned')
      }
    } catch (err) {
      console.error('Checkout error:', err)
      setError(err.message || 'Something went wrong. Please try again.')
      setIsProcessing(false)
    }
  }

  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-pp-ivory flex items-center justify-center">
        <div className="text-center">
          <h1 className="font-display text-display-md text-pp-ink mb-4">
            Your cart is empty
          </h1>
          <Button as={Link} to="/shop">
            Continue Shopping
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-pp-linen">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <Link
            to="/cart"
            className="flex items-center gap-2 text-pp-stone hover:text-pp-charcoal transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
            Back to Cart
          </Link>
          <div className="flex items-center gap-2 text-pp-sage text-sm">
            <Lock className="w-4 h-4" />
            Secure Checkout
          </div>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Checkout Form */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="lg:col-span-3"
          >
            <form onSubmit={handleCheckout} className="space-y-6">
              {error && (
                <div className="p-4 bg-red-50 border border-red-100 rounded-lg text-red-600 text-sm">
                  {error}
                </div>
              )}

              {/* Contact Information */}
              <div className="bg-white rounded-2xl p-6 border border-pp-sand/50">
                <h2 className="font-display text-xl text-pp-ink mb-6">
                  Contact Information
                </h2>
                <Input
                  label="Email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Shipping Address */}
              <div className="bg-white rounded-2xl p-6 border border-pp-sand/50">
                <h2 className="font-display text-xl text-pp-ink mb-6">
                  Shipping Address
                </h2>
                <div className="grid sm:grid-cols-2 gap-4">
                  <Input
                    label="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                  <Input
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                  <div className="sm:col-span-2">
                    <Input
                      label="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="sm:col-span-2">
                    <Input
                      label="Apartment, suite, etc. (optional)"
                      name="apartment"
                      value={formData.apartment}
                      onChange={handleChange}
                    />
                  </div>
                  <Input
                    label="City"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                  <div className="grid grid-cols-2 gap-4">
                    <Input
                      label="State"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                    />
                    <Input
                      label="Postcode"
                      name="postcode"
                      value={formData.postcode}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="sm:col-span-2">
                    <Input
                      label="Phone"
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Shipping Method */}
              <div className="bg-white rounded-2xl p-6 border border-pp-sand/50">
                <div className="flex items-center gap-3">
                  <Truck className="w-5 h-5 text-pp-sage" />
                  <div className="flex-1">
                    <h3 className="font-medium text-pp-ink">Standard Shipping</h3>
                    <p className="text-sm text-pp-stone">
                      {shipping === 0 ? 'Free' : formatPrice(shipping)} · 3-5 business days
                    </p>
                  </div>
                  {shipping > 0 && (
                    <p className="text-xs text-pp-sage">
                      Free shipping on orders over $75
                    </p>
                  )}
                </div>
              </div>

              {/* Payment Options */}
              <div className="bg-white rounded-2xl p-6 border border-pp-sand/50">
                <div className="flex items-center gap-3 mb-4">
                  <CreditCard className="w-5 h-5 text-pp-sage" />
                  <h2 className="font-display text-xl text-pp-ink">Payment Method</h2>
                </div>

                {/* Credit Card / Stripe */}
                <div className="space-y-3">
                  <button
                    type="submit"
                    disabled={isProcessing}
                    className="w-full flex items-center justify-between p-4 border-2 border-pp-ink rounded-xl hover:bg-pp-linen transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <CreditCard className="w-5 h-5 text-pp-charcoal" />
                      <span className="font-medium text-pp-ink">Credit / Debit Card</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <div className="w-8 h-5 bg-[#1A1F71] rounded flex items-center justify-center">
                        <span className="text-white text-[8px] font-bold">VISA</span>
                      </div>
                      <div className="w-8 h-5 bg-[#EB001B] rounded-l-full bg-gradient-to-r from-[#EB001B] to-[#F79E1B] flex items-center justify-center">
                        <div className="w-3 h-3 bg-[#FF5F00] rounded-full"></div>
                      </div>
                    </div>
                  </button>

                  {/* PayPal - Coming Soon */}
                  <div className="relative">
                    <button
                      type="button"
                      disabled
                      className="w-full flex items-center justify-between p-4 border border-pp-sand rounded-xl bg-pp-sand/20 cursor-not-allowed opacity-60"
                    >
                      <div className="flex items-center gap-3">
                        <PayPalLogo />
                      </div>
                      <span className="text-xs text-pp-stone bg-pp-sand px-2 py-1 rounded-full">Coming Soon</span>
                    </button>
                  </div>

                  {/* Afterpay - Coming Soon */}
                  <div className="relative">
                    <button
                      type="button"
                      disabled
                      className="w-full flex items-center justify-between p-4 border border-pp-sand rounded-xl bg-pp-sand/20 cursor-not-allowed opacity-60"
                    >
                      <div className="flex items-center gap-3">
                        <div className="bg-[#B2FCE4] px-2 py-1 rounded">
                          <span className="text-black font-bold text-sm">afterpay</span>
                        </div>
                        <span className="text-xs text-pp-stone">4 interest-free payments</span>
                      </div>
                      <span className="text-xs text-pp-stone bg-pp-sand px-2 py-1 rounded-full">Coming Soon</span>
                    </button>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-4 pt-4 border-t border-pp-sand/50">
                  <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/au.svg" alt="Australia" className="w-6 h-4 rounded" />
                  <span className="text-xs text-pp-stone">Australian dollars (AUD)</span>
                </div>
              </div>

              {isProcessing && (
                <div className="flex items-center justify-center gap-2 text-pp-terracotta">
                  <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
                  <span className="text-sm">Redirecting to secure payment...</span>
                </div>
              )}

              <p className="text-xs text-pp-stone text-center">
                Secure payment powered by Stripe. Your card details are never stored on our servers.
              </p>
            </form>
          </motion.div>

          {/* Order Summary */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="lg:col-span-2"
          >
            <div className="bg-white rounded-2xl p-6 border border-pp-sand/50 sticky top-24">
              <h2 className="font-display text-xl text-pp-ink mb-6">
                Order Summary
              </h2>

              <div className="space-y-4 mb-6">
                {cart.map((item) => (
                  <div key={item.id} className="flex gap-4">
                    <div className="relative w-16 h-16 bg-pp-sand/30 rounded-lg flex-shrink-0 flex items-center justify-center">
                      <span className="text-pp-stone text-xs">Img</span>
                      <span className="absolute -top-2 -right-2 w-5 h-5 bg-pp-charcoal text-white text-xs rounded-full flex items-center justify-center">
                        {item.quantity}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-pp-ink truncate">
                        {item.name}
                      </p>
                      <p className="text-xs text-pp-stone">{item.ageRange}</p>
                    </div>
                    <span className="text-sm text-pp-charcoal">
                      {formatPrice(item.price * item.quantity)}
                    </span>
                  </div>
                ))}
              </div>

              <div className="border-t border-pp-sand pt-4 space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-pp-stone">Subtotal</span>
                  <span className="text-pp-charcoal">{formatPrice(cartTotal)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-pp-stone">Shipping</span>
                  <span className="text-pp-charcoal">
                    {shipping === 0 ? 'Free' : formatPrice(shipping)}
                  </span>
                </div>
              </div>

              <div className="border-t border-pp-sand mt-4 pt-4">
                <div className="flex justify-between font-medium">
                  <span className="text-pp-ink">Total</span>
                  <span className="text-pp-ink">{formatPrice(total)}</span>
                </div>
                <p className="text-xs text-pp-stone mt-1">Including GST</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}
